import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getServices } from "../../api";
import { changeSelectedService } from "../../store/slice/orderSlice";
import { getTimeFromMins, convertPrice } from "../../config";
import { useNavigate } from "react-router-dom";

const ServicesList = () => {
  const { selectedStudio, selectedMaster, selectedService, selectedCatService } = useSelector(
    (state) => state.orderReducer
  );
  const dispatch = useDispatch();
  const [services, setServices] = useState(null);
  const redirect = useNavigate();

  useEffect(() => {
    selectedStudio && selectedCatService && getServicesStudioByCat(selectedStudio.id, selectedCatService.id);
  }, []);

  const getServicesStudioByCat = async (studioId, catId) => {
    const services = await getServices(studioId, catId);
    setServices(services.data);
  };

  const selectService = (service) => {
    return () => {
      dispatch(changeSelectedService(service));
      redirect("/booking/master");
    };
  };

  return (
    <div className="service-list">
      <div className="service-list__title">
        Selected category service: <span>{selectedCatService?.title}</span>
      </div>
      <div className="service-list__list">
        {services &&
          services.map(
            (service) =>(
                <div className="service-list__item service" key={service.id}>
                  <div className="service__img">
                    <img src={service.img} alt="service image" />
                  </div>
                  <div className="service__info">
                    <div className="title">{service.title}</div>
                    <div className="cost-and-duration">
                      {service.priceList?.length && (
                        <>
                          <div className="cost">from {convertPrice(service.priceList?.[0]?.price)} €</div>
                          <div className="point"></div>
                        </>
                      )}
                      <div className="duration">{getTimeFromMins(service.duration)} h.</div>
                    </div>
                  </div>
                  <div className="service__select">
                    <button className="select-btn" onClick={selectService(service)}>
                      Select +
                    </button>
                  </div>
                </div>
              )
          )}
      </div>
    </div>
  );
};

export default ServicesList;
